import React, { memo } from 'react';
const reasons = ['Te meten teoría sin contexto.', 'Te hacen memorizar reglas antes de poder hablar.', 'Te dan vocabulario que no usas.', 'No existe un "camino diario" claro, por eso abandonas.'];
export function WhyTraditionalFails() {
  return <section className="w-full bg-[#F8F9FA] py-8 md:py-14 px-4" data-id="element-185">
      <div className="max-w-3xl mx-auto" data-id="element-186">
        <h2 className="text-2xl md:text-4xl font-bold text-[#1A1A2E] text-center mb-6" data-id="element-187">
          Lo tradicional falla por 4 razones:
        </h2>

        <ol className="space-y-3 mb-6" data-id="element-188">
          {reasons.map((reason, index) => <li key={index} className="flex items-start gap-4" data-id="element-189">
              <span className="flex-shrink-0 w-8 h-8 bg-[#EF4444] text-white rounded-full flex items-center justify-center font-bold" data-id="element-190">
                {index + 1}
              </span>
              <span className="text-lg text-[#4A4A5A] pt-1" data-id="element-191">{reason}</span>
            </li>)}
        </ol>

        <div className="border-l-4 border-[#FF6B00] bg-[#FFF7ED] p-6 md:p-8 rounded-r-xl" data-id="element-192">
          <p className="text-xl md:text-2xl font-bold mb-2 text-[#1A1A2E]" data-id="element-193">
            Inglés en Acción es lo contrario:
          </p>
          <p className="text-lg md:text-xl text-[#4A4A5A]" data-id="element-194">
            menos explicación, más uso real, más repetición inteligente.
          </p>
        </div>
      </div>
    </section>;
}